import { render } from "./BaseRadioGroup.vue?vue&type=template&id=39f3f43e&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=39f3f43e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39f3f43e"

export default script